import { LitElement, html} from 'lit';
import { unsafeHTML } from "lit/directives/unsafe-html.js";

export class StarSelector extends LitElement {
    value: number = 0;
    type?: string;
    static get properties() {
        return {
            value: { type: Number },
            type: { type: String }
        };
    }
    // get fontawesome styling and bootstrap styling by rendering without a shadowroot
    createRenderRoot() {
        return this;
    }
    render() {
        return html`
            <wers-stars type=${this.type ?? "cool"} .value=${this.value ?? 0}></wers-stars><br />
            <input type="range" min="0" step="5" max="100" .value=${this.value*10} @input=${(e) => this.inputChanged(e)} />
         `;
    }
    inputChanged(e: any) {
        this.value = e.target.value/10;
        this.render();
    }

}

export class Stars extends LitElement {
    value: number=0;
    type?: string;
    static get properties() {
        return {
            value: { type: Number },
            type: { type: String }
        };
    }
    // get fontawesome styling and bootstrap styling by rendering without a shadowroot
    createRenderRoot() {
        return this;
    }

    render() {
        const stars = (value: number) => {
            value = value ?? 0;
            const hasHalf = ((value * 10) % 10) > 0;
            const starCount = Math.trunc(value);
            let ret = "";
            for (let i = 0; i < starCount; i++) ret += `<i class="fa fa-star" aria-hidden="true"></i>`;
            if (hasHalf) ret += `<i class="fa fa-star-half" aria-hidden="true"></i>`;
            return ret;
        };

        return html`<span class=${(this.type ??"cool") == "cool"  ? "text-primary" : "text-danger"}>${unsafeHTML(stars(this.value))}</span>`;
    }

}

(function () {
    customElements.define('wers-stars', Stars);
    customElements.define('wers-star-picker', StarSelector);

})();
